module.exports = __webpack_public_path__ + "static/media/hl_finance.f2c8a241.jpeg";